import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import Properties from "../const/Properties";
import CustomTable from "../thema/tema1/component/CustomTable"
import CustomModal from "../thema/tema1/component/CustomModal"
import axios from 'axios';

const active = {Home: "active"};

class Firma extends React.Component {
    componentDidMount() {

    }
    constructor(props){
        super(props);
        if(localStorage.getItem("token")=="")
        {
            window.location = '/';
            return false;
        }
        this.state = {
            firmaAdi: "",
            firmaTelefon: "",
            firmaAdres: "",
            firmalar:[],
            content:[],
            pageCount:0,
            totalRow:0,
            startRow:0,
            endRow:0,
            silId:0,
            duzenleId:0,
            silModal:'none',
            title:["FİRMA ADI","FİRMA TELEFON","FİRMA ADRES","İŞLEMLER"],
            showDuzenle:false,
            duzenle:false,
            error: 0
        };
        this.handlePageClick({selected:0});
        this.getTotalRow();
    }
    onChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }
    setSil = (e)=>{
        this.setState({silId:e.id});
    }
    setDuzenle = (e)=>{
        this.setState({firmaAdi:e.firmaAdi});
        this.setState({firmaTelefon:e.firmaTelefon});
        this.setState({firmaAdres:e.firmaAdres});
        this.setState({duzenleId:e.id});
        this.setState({showDuzenle:true});
    }
    geri = (e)=>{
        this.setState({firmaAdi:""});
        this.setState({firmaTelefon:e.firmaTelefon});
        this.setState({firmaAdres:e.firmaAdres});
        this.setState({showDuzenle:false});
    }
    silModal = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/firma/delete/'+this.state.silId,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
        .then(res => {
            this.getTotalRow();
            this.handlePageClick({selected:0});
            window.successful("Firma Silindi");
            this.setState({firmaAdi:""});
            this.setState({firmaTelefon:""});
            this.setState({firmaAdres:""});
        }).catch(res =>{
            window.unsuccessful("Firma Silinemedi.");
    });
        window.disableModal();
    }
    save = e => {
        let status = true;
        if(status)
        {
            axios({
                method: 'post',
                url:  Properties.baseUrl+'/firma/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization" : "Bearer " + localStorage.getItem("token")
                },
                data: {
                    firmaAdi: this.state.firmaAdi,
                    firmaTelefon: this.state.firmaTelefon,
                    firmaAdres: this.state.firmaAdres,
                    id:(this.state.showDuzenle?this.state.duzenleId:0)
                }
            })
                .then(res => {
                    this.getTotalRow();
                    this.handlePageClick({selected:0});
                    window.successful((this.state.showDuzenle?"Firma Güncellendi.":"Firma Kaydedildi"));
                    this.setState({firmaAdi:""});
                    this.setState({firmaTelefon:""});
                    this.setState({firmaAdres:""});
                }).catch(res =>{
                    window.unsuccessful((this.state.showDuzenle?"Firma Güncellenemedi.":"Firma Kaydedilemedi."));
            });
            if(this.state.showDuzenle)
                this.setState({showDuzenle:false});
        }
    }
    getTotalRow = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/firma/toplam/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.setState({totalRow:res.data});
                this.setState({pageCount:res.data/10});
            });
    }
    handlePageClick=e=>{
        this.setState({ startRow: (e.selected*10)+1});
        this.setState({ endRow:((e.selected+1)*10)});
        axios({
            method: 'get',
            url: Properties.baseUrl+'/firma/sayfaliGetir/'+e.selected,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.firmaAdi = eleman.firmaAdi;
                    elemanIc.firmaTelefon = eleman.firmaTelefon;
                    elemanIc.firmaAdres = eleman.firmaAdres;
                    getData.push(eleman);
                });
                this.setState({firmalar:getData});
                let content = getData.map((item) =>
                                 (<tr>
                                    <td>{item.firmaAdi}</td>  
                                    <td>{item.firmaTelefon}</td>
                                    <td>{item.firmaAdres}</td>
                                    <td>
                                        <div className="row">
                                            <div className="col-3">
                                                <button type="button" onClick={e => this.setDuzenle(item)}
                                                        className="btn btn-block btn-outline-info">DÜZENLE
                                                </button>
                                            </div>
                                            <div className="col-2">
                                                <button type="button" className="btn btn-block btn-outline-danger"
                                                        onClick={e => this.setSil(item)} data-toggle="modal"
                                                        data-target="#modal-default">SİL
                                                </button>

                                            </div>
                                        </div>

                                    </td>
                                 </tr>));
                this.setState({content: content});
            });
    }
    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu firma="active" yonetim="menu-is-opening menu-open"  yonetimacik={{display:'Block'}}/>
                <PageContext>
                    <div className="card card-primary">
                        <div className="card-header">
                        <h3 className="card-title" style={this.state.showDuzenle?{display:'none'}:{display:'block'}}>Ekle</h3>
                            <h3 className="card-title" style={this.state.showDuzenle?{display:'block'}:{display:'none'}}>Düzenle</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Firma Adı</label>
                                        <input type="text" value={this.state.firmaAdi} className="form-control"
                                               name="firmaAdi" onChange={this.onChange}
                                               placeholder="Adı"/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Firma Telefon</label>
                                        <input type="text" value={this.state.firmaTelefon} className="form-control"
                                               name="firmaTelefon" onChange={this.onChange}
                                               placeholder="Telefon"/>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputEmail1">Firma Adres</label>
                                        <input type="text" value={this.state.firmaAdres} className="form-control"
                                               name="firmaAdres" onChange={this.onChange}
                                               placeholder="Adres"/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1"></label>
                                        <button onClick={this.save}
                                                style={this.state.showDuzenle ? {display: 'none'} : {
                                                    margin: "10px",
                                                    display: 'block'
                                                }} type="button" className="btn btn-primary">Ekle
                                        </button>
                                        <button onClick={this.save} style={this.state.showDuzenle ? {
                                            margin: "10px",
                                            float: "left",
                                            display: 'block'
                                        } : {display: 'none'}} type="button" className="btn btn-primary">Düzenle
                                        </button>
                                        <button onClick={this.geri} style={this.state.showDuzenle ? {
                                            float: "left",
                                            margin: "10px",
                                            display: 'block'
                                        } : {display: 'none'}} type="button" className="btn btn-info">Geri
                                        </button>

                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Bilgileri</h3>
                        </div>
                        <div className="card-body">
                            <CustomTable state={this.state} getTotalRow={this.getTotalRow}
                                         handlePageClick={this.handlePageClick}></CustomTable>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.silModal} title={"Firma Sil"}
                             content={"Firmayı Silmek İstediğinizden Emin Misiniz?"}></CustomModal>

            </div>);
    }
}


export default Firma;
